import Alt from 'alt'
import CartActions from 'actions/CartActions'
import CartStore from 'stores/CartStore'

class Flux extends Alt {

	constructor() {
		super()
		this.addActions('cartActions', CartActions)
		this.addStore('cartStore', CartStore)
	}

}

export default Flux


/** WEBPACK FOOTER **
 ** ./src/scripts/Flux.js
 **/